// extracted by mini-css-extract-plugin
export default {"contact":"css_contact__3SBx6"};